import React from 'react';
import { styled } from '@mui/material/styles';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { Button } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';

const PREFIX = 'SpeakersToolbar';

const classes = {
  root: `${PREFIX}-root`,
  row: `${PREFIX}-row`,
  spacer: `${PREFIX}-spacer`,
};

const Root = styled('div')(({ theme }) => ({
  [`&.${classes.root}`]: {
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(3),
  },

  [`& .${classes.row}`]: {
    display: 'flex',
  },

  [`& .${classes.spacer}`]: {
    flexGrow: 1,
  },
}));

const SpeakersToolbar = props => {
  const { className, meetupId, ...rest } = props;

  return (
    <Root {...rest} className={clsx(classes.root, className)}>
      <div className={classes.row}>
        <span className={classes.spacer} />
        <RouterLink to={'/m/' + meetupId + '/program/speaker/add'}>
          <Button color='primary' variant='contained'>
            Добавить спикера
          </Button>
        </RouterLink>
      </div>
    </Root>
  );
};

SpeakersToolbar.propTypes = {
  className: PropTypes.string,
  meetupId: PropTypes.string,
};

export default SpeakersToolbar;
